import { render } from "./os.vue?vue&type=template&id=1bda2b28&scoped=true"
import script from "./os.vue?vue&type=script&lang=js"
export * from "./os.vue?vue&type=script&lang=js"

import "./os.vue?vue&type=style&index=0&id=1bda2b28&scoped=true&lang=css"

import exportComponent from "X:\\GRV\\CPS5\\Projetos\\CPSDashApontamento\\apontamentowebvueV3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bda2b28"]])

export default __exports__